// Copyright (c) 2016 Deere & Company

import Report, {getDefaultState} from '../../duplicate-pin-plate/state/report';
import actions from '../../actions-list';

const updateDuplicatePinPlateReport = (state, action) =>
    Report.update(state, {
        $set: action.data
    });

export default (state = getDefaultState(), action) => {

    const actionTypes = {
        [actions.CREATE_DUPLICATE_PIN_PLATE_REPORT_SUCCESS]: updateDuplicatePinPlateReport,
        [actions.RESET_REPORT_SEARCH_RESULTS]: updateDuplicatePinPlateReport
    };

    const reducer = actionTypes[action.type];

    return reducer ?
        reducer(state, action) :
        state;

};



// WEBPACK FOOTER //
// ./src/reports/duplicate-pin-plate/reducers/report.js